import { ZodpovednyPredkladatel, ZodpovednyPredkladatelListApi } from 'elegislativa-frontend-ts-axios';
import { ClientResponse } from '../../model/ClientResponse';
import { Pouzivatel } from '../../model/iam/Pouzivatel';
import apiConfiguration from '../configuration/apiConfiguration';
import { elegislativaPrefixPath } from '../configuration/apiConfigurationConstants';
import Uuid from '../../model/Uuid';

const client = new ZodpovednyPredkladatelListApi(apiConfiguration(elegislativaPrefixPath));

function map(pouzivatelList: ZodpovednyPredkladatel[]): Pouzivatel[] {
  return pouzivatelList.map(pouzivatel => ({
    uuid: pouzivatel.uuid,
    nazov: pouzivatel.fullName,
    nazovPozicie: '',
  }));
}

export const fetchZodpovednyPredkladatelList = async (
  userFullNameContains?: string,
  limit?: number,
  headers?: object,
): Promise<ClientResponse<Pouzivatel[]>> => {
  const {
    data,
    status,
  } = await client.getZodpovednyPredkladatelList(
    userFullNameContains,
    limit,
    null,
    headers,
  );
  return {
    data: map(data),
    responseCode: status,
  };
};

export const fetchZodpovednyPredkladatel = async (
  userUuid?: Uuid,
  // eslint-disable-next-line default-param-last
  execute = true,
  headers?: object,
): Promise<ClientResponse<Pouzivatel[]>> => {
  if (!execute) {
    return {
      data: [],
      responseCode: null,
    };
  }
  const {
    data,
    status,
  } = await client.getZodpovednyPredkladatelList('', 1000, userUuid, headers);
  return {
    data: data ? map(data.filter(predkladatel => predkladatel.uuid === userUuid)) : [],
    responseCode: status,
  };
};
